export default {
  'login.title': 'MyStorageX',
  'login.welcome': 'Bienvenido a MyStorageX',
  'login.description': 'MyStorageX es tu asistente de almacenamiento en la nube, que ofrece almacenamiento y gestión de archivos seguros y convenientes. Accede a tus archivos en cualquier momento y lugar.',
  'login.email.placeholder': 'Correo o nombre de usuario',
  'login.password.placeholder': 'Contraseña',
  'login.button': 'Iniciar sesión',
  'login.loading': 'Iniciando sesión...',
  'login.divider': 'o',
  'login.signup': '¿No tienes cuenta?',
  'login.signup.link': 'Regístrate',
  'login.error.default': 'Error al iniciar sesión, por favor inténtalo más tarde',
  'login.success': 'Sesión iniciada',
  'login.forgotPassword': '¿Olvidaste tu contraseña?',
  'login.forgotPassword.link': 'Restablecer aquí',
  'signup.page.title': 'Registro - MyStorageX',
  'signup.title': 'MyStorageX',
  'signup.welcome': 'Bienvenido a MyStorageX',
  'signup.description': 'Crea tu cuenta y comienza tu viaje de almacenamiento en la nube',
  'signup.username.placeholder': 'Ingresa nombre de usuario',
  'signup.email.placeholder': 'Ingresa correo',
  'signup.password.placeholder': 'Ingresa contraseña',
  'signup.confirmPassword.placeholder': 'Confirma contraseña',
  'signup.button': 'Registrarse',
  'signup.loading': 'Registrando...',
  'signup.login': '¿Ya tienes cuenta?',
  'signup.login.link': 'Inicia sesión',
  'signup.error.passwordMismatch': 'Las contraseñas no coinciden',
  'signup.error.default': 'Error al registrarse, por favor inténtalo más tarde',
  'signup.success': 'Registro exitoso',
  'signup.username.rule.length': 'El nombre de usuario debe tener entre 4 y 10 caracteres',
  'signup.username.rule.format': 'Solo se permiten letras, números, guiones bajos y guiones',
  'signup.password.rule.length': 'La contraseña debe tener entre 6 y 20 caracteres',
  'signup.password.rule.lowercase': 'Debe contener letras minúsculas',
  'signup.password.rule.uppercase': 'Debe contener letras mayúsculas',
  'signup.password.rule.number': 'Debe contener números',
  'signup.password.rule.special': 'Debe contener caracteres especiales',
  'resetPassword.page.title': 'Restablecer contraseña - MyStorageX',
  'resetPassword.page.description': 'Restablece tu contraseña de cuenta MyStorageX',
  'resetPassword.title': 'Restablecer contraseña',
  'resetPassword.email.placeholder': 'Ingresa tu correo electrónico',
  'resetPassword.code.placeholder': 'Ingresa el código de verificación',
  'resetPassword.password.placeholder': 'Ingresa nueva contraseña',
  'resetPassword.button': 'Restablecer',
  'resetPassword.button.loading': 'Restableciendo...',
  'resetPassword.backToLogin': 'Volver al inicio de sesión',
  'resetPassword.sendCode': 'Obtener código',
  'resetPassword.sendCode.sending': 'Enviando...',
  'resetPassword.sendCode.retry': 'Reintentar en {seconds}s',
  'resetPassword.error.emailRequired': 'Por favor ingresa tu correo electrónico',
  'resetPassword.error.codeRequired': 'Por favor ingresa el código de verificación',
  'resetPassword.error.passwordRequired': 'Por favor ingresa una nueva contraseña',
  'resetPassword.error.passwordLength': 'La contraseña debe tener entre 6 y 20 caracteres',
  'resetPassword.error.codeLength': 'El código de verificación debe tener 6 dígitos',
  'resetPassword.success.codeSent': 'El código de verificación ha sido enviado a tu correo',
  'resetPassword.success.reset': 'Contraseña restablecida con éxito',
  'resetPassword.error.sendFailed': 'Error al enviar el código de verificación, por favor intenta más tarde',
  'resetPassword.error.resetFailed': 'Error al restablecer la contraseña, por favor intenta más tarde',
  'signup.verificationCode.placeholder': 'Ingrese el código de verificación',
  'signup.verificationCode.send': 'Obtener código',
  'signup.verificationCode.sending': 'Enviando...',
  'signup.verificationCode.retry': 'Reintentar en {seconds}s',
  'signup.verificationCode.success': 'Código de verificación enviado',
  'signup.verificationCode.error': 'Error al enviar el código',
  'signup.verificationCode.required': 'Por favor ingrese el código de verificación',
  'signup.verificationCode.invalid': 'Formato de código de verificación no válido',
  'signup.error.emailRequired': 'Por favor, introduce tu dirección de correo electrónico',
  'signup.announcement': '¡La función de registro está en mantenimiento hoy!',
  'sidebar.allFiles': 'Todos los archivos',
  'sidebar.starred': 'Favoritos',
  'sidebar.folders': 'Carpetas',
  'sidebar.trash': 'Papelera',
  'sidebar.decrypt': 'Herramienta de descifrado',
  'sidebar.feedback': 'Comentarios',
  'sidebar.about': 'Acerca de',
  'sidebar.productLog': 'Actualizaciones',
  'filelist.column.name': 'Nombre',
  'filelist.column.size': 'Tamaño',
  'filelist.column.updateTime': 'Modificado',
  'filelist.column.recycletime': 'Fecha de eliminación',
  'filelist.column.actions': 'Acciones',
  'filelist.total': 'Total {total} elementos',
  'filelist.action.upload': 'Subir',
  'filelist.action.newFolder': 'Nueva carpeta',
  'filelist.action.refresh': 'Actualizar',
  'filelist.action.search': 'Buscar archivos',
  'filelist.action.batchDownload': 'Descargar',
  'filelist.action.batchDelete': 'Eliminar',
  'filelist.action.download': 'Descargar',
  'filelist.action.preview': 'Vista previa',
  'filelist.action.rename': 'Renombrar',
  'filelist.selected': '{count} seleccionados',
  'page.cloudDrive.title': 'Mi unidad en la nube',
  'page.cloudDrive.description': 'MyStorageX Cloud Drive - Almacena y gestiona tus archivos de forma segura',
  'modal.fileUpload.title': 'Subir archivos',
  'modal.fileUpload.dragText': 'Arrastra archivos aquí o haz clic para subir',
  'modal.fileUpload.start': 'Iniciar subida',
  'modal.fileUpload.cancel': 'Cancelar',
  'modal.fileUpload.clear': 'Limpiar lista',
  'modal.fileUpload.encrypt': 'Cifrar seleccionados',
  'modal.fileUpload.addMore': 'Agregar',
  'modal.fileUpload.remove': 'Quitar',
  'modal.fileUpload.error.noSelection': 'Por favor selecciona archivos para quitar',
  'modal.fileUpload.error.noEncryption': 'Por favor selecciona archivos para cifrar',
  'modal.fileUpload.error.noClear': 'No hay archivos para limpiar',
  'modal.fileUpload.error.noStart': 'No hay archivos para subir',
  'modal.fileUpload.error.noCancel': 'No hay subidas en curso para cancelar',
  'modal.fileUpload.error.fileSize': 'Tamaño de archivo excedido',
  'modal.fileUpload.error.fileType': 'Tipo de archivo no soportado',
  'modal.fileUpload.error.maxCount': 'Número máximo de archivos excedido',
  'modal.fileUpload.duplicate.title': 'El archivo ya existe',
  'modal.fileUpload.duplicate.skip': 'Omitir',
  'modal.fileUpload.duplicate.replace': 'Reemplazar',
  'modal.fileUpload.duplicate.rename': 'Renombrar',
  'modal.fileUpload.status.pending': 'Pendiente',
  'modal.fileUpload.status.uploading': 'Subiendo',
  'modal.fileUpload.status.success': 'Completado',
  'modal.fileUpload.status.error': 'Error',
  'modal.fileUpload.status.cancelled': 'Cancelado',
  'modal.fileUpload.status.duplicated': 'Duplicado',
  'modal.fileUpload.table.filename': 'Nombre del archivo',
  'modal.fileUpload.table.size': 'Tamaño',
  'modal.fileUpload.table.status': 'Estado',
  'modal.fileUpload.table.progress': 'Progreso',
  'modal.fileUpload.table.actions': 'Acciones',
  'modal.fileUpload.speed': 'Velocidad de subida',
  'modal.fileUpload.remainingTime': 'Tiempo restante',
  'modal.fileUpload.total.progress': 'Progreso total',
  'modal.fileUpload.error.message': 'Error al subir: {message}',
  'modal.fileUpload.confirm.clear': '¿Quieres limpiar la lista de subida?',
  'modal.fileUpload.confirm.cancel': '¿Quieres cancelar la subida?',
  'modal.fileUpload.clear.mobile': 'Limpiar',
  'modal.fileUpload.encrypt.mobile': 'Cifrar',
  'modal.fileUpload.addMore.mobile': 'Agregar',
  'productLog.title': 'Actualizaciones del producto',
  'security.features.title': 'Características de seguridad',
  'security.features.localDecryption.title': 'Descifrado local',
  'security.features.localDecryption.description': 'Todas las operaciones de descifrado se realizan localmente en tu navegador, el contenido del archivo y la contraseña nunca salen de tu dispositivo',
  'security.features.militaryEncryption.title': 'Cifrado militar',
  'security.features.militaryEncryption.description': 'Utiliza el algoritmo de cifrado AES-256-CBC, el estándar de cifrado simétrico más seguro que puede resistir todos los ataques conocidos',
  'security.features.privacyProtection.title': 'Protección de privacidad',
  'security.features.privacyProtection.description': 'Mecanismo estricto de protección de privacidad, no se guardan contraseñas de descifrado, no se registra contenido de archivos',
  'security.features.smartDecryption.title': 'Descifrado inteligente por bloques',
  'security.features.smartDecryption.description': 'La tecnología de descifrado inteligente por bloques mejora significativamente la velocidad de descifrado mientras reduce el uso de memoria',
  'security.features.learnMore': 'Más información',
  'security.features.modal.title': 'Detalles de características de seguridad',
  'security.features.modal.close': 'Cerrar',
  'decrypt.security.modal.title': 'Aviso de seguridad',
  'decrypt.security.modal.description': 'Todas las operaciones de descifrado se realizan localmente, tu contraseña y contenido del archivo nunca se enviarán al servidor',
  'decrypt.security.modal.vip.title': 'Como usuario VIP, puedes:',
  'decrypt.security.modal.vip.feature1': 'Descifrar archivos de cualquier tamaño',
  'decrypt.security.modal.vip.feature2': 'Usar descifrado inteligente por bloques para mejor eficiencia',
  'decrypt.security.modal.vip.feature3': 'Soportar descifrado por lotes de archivos grandes',
  'decrypt.security.modal.free.title': 'Importante: El proceso de descifrado requiere aproximadamente 3 veces el tamaño del archivo en memoria del navegador.',
  'decrypt.security.modal.free.feature1': 'Los usuarios gratuitos están limitados a 4GB por archivo',
  'decrypt.security.modal.free.feature2': 'Actualiza a VIP para descifrar archivos de cualquier tamaño',
  'decrypt.security.modal.free.feature3': 'Si el navegador se bloquea, considera actualizar a VIP para usar el descifrado por bloques',
  'security.diagram.plaintext.block1': 'Bloque de texto plano 1',
  'security.diagram.plaintext.block2': 'Bloque de texto plano 2',
  'security.diagram.ciphertext.block1': 'Bloque de texto cifrado 1',
  'security.diagram.ciphertext.block2': 'Bloque de texto cifrado 2',
  'security.diagram.key': 'Clave',
  'security.diagram.aes.encryption': 'Cifrado AES',
  'security.diagram.xor.operation': 'Operación XOR',
  'security.diagram.iv': 'Vector de inicialización',
  'decrypt.fileList.empty': 'No hay archivos, por favor agrega archivos para descifrar',
  'decrypt.fileList.column.name': 'Nombre del archivo',
  'decrypt.fileList.column.size': 'Tamaño',
  'decrypt.fileList.column.status': 'Estado',
  'decrypt.fileList.column.actions': 'Acciones',
  'decrypt.fileList.status.pending': 'Pendiente',
  'decrypt.fileList.status.decrypting': 'Descifrando',
  'decrypt.fileList.status.success': 'Completado',
  'decrypt.fileList.status.error': 'Error',
  'decrypt.fileList.action.info': 'Info',
  'decrypt.password.modal.title': 'Ingresa contraseña de descifrado',
  'decrypt.password.modal.placeholder': 'Ingresa contraseña',
  'decrypt.password.modal.hint': 'Ingresa la contraseña que estableciste durante el cifrado, solo se usará para el descifrado local',
  'decrypt.message.invalidFile': 'Por favor selecciona solo archivos .encrypted',
  'decrypt.message.duplicate': 'El archivo "{filename}" ya existe, se eliminó automáticamente el duplicado',
  'decrypt.message.oversizeTitle': 'Tamaño de archivo excedido',
  'decrypt.message.oversizeContent': 'Los siguientes archivos exceden el límite gratuito (4GB):',
  'decrypt.message.oversizeHint': 'Actualiza a VIP para descifrar archivos de cualquier tamaño',
  'decrypt.message.selectFile': 'Por favor selecciona archivos para descifrar',
  'decrypt.message.enterPassword': 'Por favor ingresa la contraseña de descifrado',
  'decrypt.message.decryptSuccess': 'El archivo {filename} ha sido guardado',
  'decrypt.message.saveCancel': 'Se canceló el guardado del archivo {filename}',
  'decrypt.message.downloadSuccess': 'El archivo {filename} se ha guardado en la carpeta de descargas',
  'decrypt.message.decryptError': 'Error al descifrar el archivo {filename}: {error}',
  'decrypt.message.batchError': 'Error en el descifrado por lotes, por favor inténtalo de nuevo',
  'sideMenu.storageInfo.title': 'Espacio de almacenamiento',
  'sideMenu.storageInfo.usage': 'Usado {used} / Total {total}',
  'sideMenu.storageStats.title': 'Estadísticas de almacenamiento',
  'sideMenu.storageStats.overview': 'Resumen',
  'sideMenu.storageStats.totalFiles': 'Total de archivos',
  'sideMenu.storageStats.totalSize': 'Tamaño total',
  'sideMenu.storageStats.fileTypes': 'Distribución de tipos de archivo',
  'sideMenu.storageStats.providers': 'Proveedores de servicio',
  'common.default': 'Predeterminado',
  'common.regionCode': 'Código de región',
  'common.nodeType': 'Tipo de nodo',
  'common.storageUsed': 'Espacio usado',
  'common.storageAvailable': 'Espacio disponible',
  'common.storageLimit': 'Capacidad total',
  'common.storageUsageDetail': 'Usado {used} / Total {total}',
  'common.defaultNode': 'Nodo predeterminado',
  'cloudDrive.nodeSelect.title': 'Seleccionar nodo de almacenamiento',
  'cloudDrive.nodeSelect.addNode': 'Agregar nodo de almacenamiento',
  'cloudDrive.nodeSelect.deleteConfirm.title': 'Confirmar eliminación del nodo',
  'cloudDrive.nodeSelect.deleteConfirm.content': '¿Está seguro de que desea eliminar el nodo "{nodeName}"? ¡Esta acción no se puede deshacer!',
  'cloudDrive.nodeSelect.deleteSuccess': 'Nodo eliminado exitosamente',
  'cloudDrive.nodeSelect.deleteFailed': 'Error al eliminar el nodo',
  
  // Creación de nodo
  'cloudDrive.nodeCreate.title': 'Agregar nodo de almacenamiento',
  'cloudDrive.nodeCreate.selectProvider': 'Seleccionar proveedor de nube',
  'cloudDrive.nodeCreate.nodeName': 'Nombre del nodo',
  'cloudDrive.nodeCreate.nodeNamePlaceholder': 'Dejar vacío para usar el nombre predeterminado',
  'cloudDrive.nodeCreate.nameMaxLength': 'El nombre del nodo no puede exceder los 50 caracteres',
  'cloudDrive.nodeCreate.noProviders': 'No hay proveedores de nube disponibles',
  'cloudDrive.nodeCreate.pingLatency': 'Latencia {value} ms',
  'cloudDrive.nodeCreate.pingTesting': 'Probando la latencia...',
  'cloudDrive.nodeCreate.pingFailed': 'Error al probar la latencia',
  'cloudDrive.nodeCreate.pingUnavailable': 'Latencia no disponible',
  'cloudDrive.nodeCreate.sortByLatency': 'Ordenar por latencia',
  'cloudDrive.nodeCreate.selectRegion': 'Seleccionar región',
  'cloudDrive.nodeCreate.selectedRegion': 'Región seleccionada',
  'cloudDrive.nodeCreate.noRegions': 'No hay regiones disponibles',
  'cloudDrive.nodeCreate.selectProviderPlaceholder': 'Seleccione un proveedor de nube',
  'cloudDrive.nodeCreate.selectProviderRequired': 'Por favor seleccione un proveedor de nube primero',
  'cloudDrive.nodeCreate.selectRegionRequired': 'Por favor seleccione una región primero',
  'cloudDrive.nodeCreate.loadProvidersFailed': 'Error al cargar la lista de proveedores de nube',
  'cloudDrive.nodeCreate.loadRegionsFailed': 'Error al cargar la lista de regiones',
  'cloudDrive.nodeCreate.nodeType': 'Tipo de nodo',
  'cloudDrive.nodeCreate.nodeType.standard': 'Almacenamiento estándar',
  'cloudDrive.nodeCreate.nodeType.lowFreq': 'Almacenamiento de baja frecuencia',
  'cloudDrive.nodeCreate.nodeType.archive': 'Almacenamiento de archivo',
  'cloudDrive.nodeCreate.storageLimit': 'Límite de almacenamiento',
  'cloudDrive.nodeCreate.storageLimitRequired': 'Por favor ingrese el límite de almacenamiento',
  'cloudDrive.nodeCreate.storageLimitMin': 'El límite de almacenamiento no puede ser menor a 1GB',
  'cloudDrive.nodeCreate.storageLimitPlaceholder': 'Ingrese el límite de almacenamiento (GB)',
  'cloudDrive.nodeCreate.success': 'Nodo de almacenamiento creado exitosamente',
  'cloudDrive.nodeCreate.failed': 'Error al crear el nodo de almacenamiento',
  
  // Edición de nodo
  'cloudDrive.nodeEdit.title': 'Editar nodo',
  'cloudDrive.nodeEdit.name': 'Nombre del nodo',
  'cloudDrive.nodeEdit.nameRequired': 'Por favor ingrese el nombre del nodo',
  'cloudDrive.nodeEdit.nameMaxLength': 'El nombre del nodo no puede exceder los 50 caracteres'
}; 